import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    marginTop: 8,
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  menuContainer: {
    '& .MuiPaper-root': {
      backgroundColor: '#2c3940',
    },
  },
  titleButtonsQuickAccess: {
    fontFamily: 'Roboto',
    fontSize: 16,
    fontWeight: 500,
    letterSpacing: 0.16,
    textAlign: 'center',
    color: '#35a0d9',
  },
  createNewFolderIcon: {
    width: 16,
    height: 15.12,
    marginRight: 10.2,
  },
  sortByIcon: {
    width: 10.5,
    height: 6.2,
    marginLeft: 5.6,
  },
}));
